import { render, staticRenderFns } from "./MovableTextBoxBehaviorEditor.vue?vue&type=template&id=4d88f41e&scoped=true&"
import script from "./MovableTextBoxBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./MovableTextBoxBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88f41e",
  null
  
)

export default component.exports